import React from "react";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  IconButton,
  Input,
  InputLabel,
  ListItemText,
  Menu,
  MenuItem,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TablePagination,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { EnhancedTableToolbar } from "./EnhancedTableToolbar";
import EnhancedTableHead from "./EnhancedTableHead";
import { DesktopDatePicker, LocalizationProvider } from "@mui/lab";
import DateAdapter from "@mui/lab/AdapterDateFns";
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { withStyles } from "@mui/styles";
import { tooltipClasses } from "@mui/material/Tooltip";
import spinner from "../assign-prescriptions/images/spinner.gif";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import moment from "moment";
import { toast } from "react-toastify";
import { withTranslation } from "react-i18next";
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { frFR } from '@mui/material/locale';
import { enUS } from '@mui/material/locale';

const localeTheme = createTheme(
  {

  },
  localStorage.getItem('i18nextLng') === 'en' ? enUS : frFR,
);
const { log } = console;

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  if (array && array.length <= 0) {
    return [];
  }
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function getSorting(order, orderBy) {
  return order === "desc"
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}

const BootstrapDialogTitle = (props) => {
  const { children, onDialogClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onDialogClose && (
        <IconButton
          aria-label="close"
          onClick={onDialogClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      )}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onDialogClose: PropTypes.func.isRequired,
};

const HTMLTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#f5f5f9",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    fontSize: "0.8125rem",
    border: "1px solid #dadde9",
    borderRadius: "5px",
  },
}));

const useStyles = (theme) => ({
  primaryButton: {
    background: "#6cca98",
    color: "#fff",
    "&:hover": {
      background: "#6cca98",
      color: "#fff",
    },
    "&:disabled": {
      color: "rgba(0, 0, 0, 0.38)",
      cursor: "not-allowed",
      background: "#E4E5E8",
    },
  },
  deleteButton: {
    "&:hover": {
      background: "#6cca98",
      color: "#fff",
    },
    "&:disabled": {
      color: "rgba(0, 0, 0, 0.38)",
      cursor: "not-allowed",
      background: "#E4E5E8",
    },
  },
  spinner: {
    position: "absolute",
    background: "rgba(255,255,255,.4)",
    width: "100%",
    height: "100%",
    zIndex: "9999",
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: "calc(50% - 30.5px)",
    left: "calc(50% - 65px)",
    position: "absolute",
    width: "130px",
    userSelect: "none",
  },
});

let filterObj = {
  searchtext: "",
  pageNo: 0,
  pageSize: 10,
  sortOrder: "desc",
  sortColumn: "created_on",
  tableName: "task_manager",
  statusList: [],
  priorityList: [],
  actionList: [],
};

const PRIORITY = ["Low", "Medium", "High", "Critical"];
const STATUS = ["Open", "InProgress", "Complete"];
// const ACTION = ["Open", "Complete", "Delete", "Close"];

class TaskManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openTaskManagerDialog: false,
      taskTitle: "",
      action: "Open",
      reminderDate: new Date(),
      dueDate: new Date(),
      userDataList: [],
      selectedUserID: "",
      selectedUserName: "",
      taskTypeList: [],
      selectedTaskTypeID: "",
      selectedTaskName: "",
      status: "Open",
      priority: "Low",
      patientDataList: [],
      selectedPatientID: "",
      selectedPatientName: "",
      loadingSpinner: false,
      operation: "Add",
      taskDetails: "",
      orderCode: "",
      totalRecords: 0,
      data: [],
      isDataEmpty: false,
      selectedData: [],
      sortID: null,
      anchorEl: null,
      selectedRowID: null,
      openDeleteDialog: false,
      confirmedDeleteList: [],
      filterStatusList: [],
      filterActionList: [],
      filterPriorityList: [],
      openUserAutoComplete: false,
      openPatientAutoComplete: false,
      isTaskTitleRequired: false,
      isTaskDetailsRequired: false,
      isUserRequired: false,
      isPatientRequired: false,
      selectedUser: "",
      selectedUserInputValue: "",
      selectedPatient: "",
      selectedPatientInputValue: "",
      locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale
    };
  }

  componentDidMount = async () => {
    await this.gettingTaskManagerDetailsFromDB();
    //this.gettingUserLists();
    this.gettingTaskManagerTypesList();
    //this.gettingPatientList();
  };

  emitNotificationEvent = (UserID) => {
    window &&
      window.notificationSocket.emit("UserSendingNotificationEvent", {
        UserID,
        Message: "User sending notification events from connect!!",
      });
  };

  gettingUserLists = (queryParam) => {
    try {
      fetch(
        process.env.REACT_APP_BASEURL +
        "taskmanager/UsersList?searchText=" +
        queryParam,
        {
          method: "GET",
          withCredentials: true,
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user")).signInUserSession
                .idToken.jwtToken,
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => response.json())
        .then(async (response) => {
          if (
            response &&
            Array.isArray(response["results"]) &&
            response["results"].length > 0
          ) {
            const userDataList = response["results"].map((user) => {
              return { id: user.id, name: user.name };
            });
            this.setState({
              userDataList,
              selectedUserIDs: userDataList,
              selectedUserID: response["results"][0]["id"],
              selectedUserName: response["results"][0]["name"],
            });
          } else this.setState({ userDataList: [], selectedUserID: "" });
        });
    } catch (ErrorException) {
      log(
        "(TaskManager): Error ocurred while getting the users details!",
        ErrorException
      );
    }
  };

  gettingTaskManagerTypesList = () => {
    try {
      fetch(process.env.REACT_APP_BASEURL + "taskmanager/TaskType", {
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then(async (response) => {
          if (
            response &&
            Array.isArray(response["results"]) &&
            response["results"].length > 0
          ) {
            this.setState({
              taskTypeList: response["results"],
              selectedTaskTypeID: response["results"][0]["id"],
              selectedTaskName: response["results"][0]["name"],
            });
          } else this.setState({ taskTypeList: [], selectedTaskTypeID: "" });
        });
    } catch (ErrorException) {
      log(
        "(TaskManager): Error ocurred while getting the task types details!",
        ErrorException
      );
    }
  };

  gettingPatientList = (queryParam) => {
    try {
      fetch(
        process.env.REACT_APP_BASEURL +
        "taskmanager/PatientList?searchText=" +
        queryParam,
        {
          method: "GET",
          withCredentials: true,
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user")).signInUserSession
                .idToken.jwtToken,
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => response.json())
        .then(async (response) => {
          if (
            response &&
            Array.isArray(response["results"]) &&
            response["results"].length > 0
          ) {
            const patientDataList = response["results"].map((patient) => {
              return { id: patient.id, name: patient.name };
            });
            this.setState({
              patientDataList,
              selectedPatientID: response["results"][0]["id"],
              selectedPatientName: response["results"][0]["name"],
            });
          } else this.setState({ patientDataList: [], selectedPatientID: "" });
        });
    } catch (ErrorException) {
      log(
        "(TaskManager): Error ocurred while getting the patients details!",
        ErrorException
      );
    }
  };

  gettingTaskManagerDetailsFromDB = async () => {
    try {
      this.setState({ loadingSpinner: true });
      fetch(process.env.REACT_APP_BASEURL + "taskmanager/details", {
        method: "POST",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(filterObj),
      })
        .then((response) => response.json())
        .then(async (response) => {
          this.setState({
            loadingSpinner: false,
            totalRecords:
              response && response["results"] && response["results"]["total"],
          });
          if (
            response &&
            Array.isArray(response["results"]["results"]) &&
            response["results"]["results"].length > 0
          ) {
            this.setState({
              data: response["results"]["results"],
              isDataEmpty: false,
            });
          } else this.setState({ data: [], isDataEmpty: true });
        });
    } catch (ErrorException) {
      this.setState({ loadingSpinner: false });
      log(
        "(TaskManager): Error ocurred while getting the task details from DB!",
        ErrorException
      );
    }
  };

  handleOpenTaskManagerDialog = () => {
    this.setState({
      openTaskManagerDialog: true,
      operation: "Add",
      selectedRowID: null,
      taskTitle: "",
      action: "Open",
      reminderDate: new Date(),
      dueDate: new Date(),
      status: "Open",
      priority: "Low",
      taskDetails: "",
      orderCode: "",
      filterStatusList: [],
      filterActionList: [],
      filterPriorityList: [],
      isTaskTitleRequired: false,
      isTaskDetailsRequired: false,
      isUserRequired: false,
      isPatientRequired: false,
      selectedUser: { id: "", name: "" },
      selectedPatient: { id: "", name: "" },
      selectedUserInputValue: "",
      selectedPatientInputValue: "",
      selectedUserID: "",
      selectedPatientID: "",
    });
    this.setUserAutoCompleteAction(false);
    this.handleChangeUsers(null, null, "clear");
    this.handleChangePatients(null, null, "clear");
  };

  handleCloseTaskManagerDialog = () => {
    this.setState({ openTaskManagerDialog: false });
    this.setUserAutoCompleteAction(false);
    this.handleChangeUsers(null, null, "clear");
    this.handleChangePatients(null, null, "clear");
  };

  handleChangeTaskType = (event) => {
    const { value } = event.target;
    let selectedTaskName = "";
    let findTask = this.state.taskTypeList.find(({ id }) => id === value);
    if (findTask) {
      selectedTaskName = findTask["name"];
    }
    this.setState({
      selectedTaskTypeID: event.target.value,
      selectedTaskName,
    });
  };

  handleChangeUsers = (event, value, reason) => {
    if (reason === "selectOption") {
      const { id, name } = value;
      this.setState({
        selectedUserID: id,
        selectedUserName: name,
        selectedUser: value,
      });
    } else {
      this.setState({
        userDataList: [],
        // selectedUser: { id: "", name: "" },
        // selectedUserID: "",
        // selectedUserName: "",
      });
      this.setUserAutoCompleteAction(false);
    }
  };

  handleChangePatients = (event, value, reason) => {
    if (reason === "selectOption") {
      const { id, name } = value;
      this.setState({
        selectedPatientID: id,
        selectedPatientName: name,
        selectedPatient: value,
      });
    } else {
      this.setState({
        patientDataList: [],
        // selectedPatient: { id: "", name: "" },
        // selectedPatientID: "",
        // selectedPatientName: "",
      });
      this.setPatientAutoCompleteAction(false);
    }
  };

  renderLoaderIndicator = () => {
    const { classes } = this.props;
    return (
      this.state.loadingSpinner && (
        <Box component="div" className={classes["spinner"]}>
          <Box
            component="img"
            className={classes["spinnerImage"]}
            src={spinner}
            alt="loading"
          />
        </Box>
      )
    );
  };

  gettingOnSortTableName = (field) => {
    let tablename = "";
    if (
      [
        "TaskTitle",
        "TaskType",
        "Status",
        "Priority",
        "ReminderDate",
        "DueDate",
        "Action",
      ].includes(field)
    ) {
      tablename = "task_manager";
    }
    if (["Patient"].includes(field)) {
      tablename = "customers";
    }
    if (["User"].includes(field)) {
      tablename = "users";
    }
    return tablename;
  };

  handleRequestSort = async (event, property, field) => {
    const orderBy = property;
    let order = "desc";
    if (this.state.order === "desc") order = "asc";

    this.setState({ order, orderBy, sortID: property });
    filterObj["sortOrder"] = order;
    filterObj["sortColumn"] = field;
    filterObj["tableName"] = this.gettingOnSortTableName(orderBy);
    const { data } = this.state;
    if (data && data["length"] > 0) {
      await this.gettingTaskManagerDetailsFromDB();
    }
  };

  handleCheckBoxOrRowClick = (event, id) => {
    const { selectedData } = this.state;
    const selectedIndex = selectedData.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedData, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedData.slice(1));
    } else if (selectedIndex === selectedData.length - 1) {
      newSelected = newSelected.concat(selectedData.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedData.slice(0, selectedIndex),
        selectedData.slice(selectedIndex + 1)
      );
    }

    this.setState({ selectedData: newSelected });
  };

  isSelected = (id) => this.state.selectedData.indexOf(id) !== -1;

  handleSelectAllCheckBoxClick = (event) => {
    if (event.target.checked) {
      this.setState((state) => ({ selectedData: state.data.map((n) => n.id) }));
      return;
    }
    this.setState({ selectedData: [] });
  };

  handleOpenContextMenuClick = (event, items) => {
    event.preventDefault();
    this.setState({
      anchorEl: event.currentTarget,
      selectedRowID: items["id"],
    });
  };

  handleCloseContextMenuClick = (event) => {
    event.preventDefault();
    this.setState({ anchorEl: null, selectedRowID: null });
  };

  handleChangePage = async (event, page) => {
    event && event.preventDefault();
    filterObj["pageNo"] = page;
    const { data } = this.state;
    if (data && data["length"] > 0) {
      await this.gettingTaskManagerDetailsFromDB();
    }
  };

  handleChangeRowsPerPage = async (event) => {
    const { data } = this.state;
    filterObj["pageNo"] = 0;
    filterObj["pageSize"] = event.target.value;
    if (data && data["length"] > 0) {
      await this.gettingTaskManagerDetailsFromDB();
    }
  };

  handleStates = () => {
    let selectedData = this.state.data.find(
      ({ id }) => id === this.state["selectedRowID"]
    );
    this.setState({
      taskTitle: selectedData["task_name"],
      action: selectedData["action"],
      reminderDate: selectedData["reminder_date"],
      dueDate: selectedData["due_date"],
      selectedTaskTypeID: selectedData["task_type_id"],
      selectedTaskName: selectedData["taskType"],
      selectedUserID: selectedData["user_id"],
      selectedUserName: selectedData["userName"],
      status: selectedData["status"],
      priority: selectedData["priority"],
      taskDetails: selectedData["task_details"],
      selectedPatientID: selectedData["patient_id"],
      selectedPatientName: selectedData["patientName"],
      orderCode: selectedData["order_code"],
      selectedUser: {
        id: selectedData["user_id"],
        name: selectedData["userName"],
      },
      selectedPatient: {
        id: selectedData["patient_id"],
        name: selectedData["patientName"],
      },
    });
  };

  handleOpenView = (event) => {
    this.setState({
      operation: "View",
      openTaskManagerDialog: true,
      isTaskTitleRequired: false,
      isTaskDetailsRequired: false,
      isUserRequired: false,
      isPatientRequired: false,
    });
    this.handleStates();
    this.handleCloseContextMenuClick(event);
  };

  handleOpenEdit = (event) => {
    const selectedObject = this.state["data"].find(
      ({ id }) => id === this.state["selectedRowID"]
    );
    this.setState({
      operation: "Edit",
      openTaskManagerDialog: true,
      selectedRow: selectedObject,
      isTaskTitleRequired: false,
      isTaskDetailsRequired: false,
      isUserRequired: false,
      isPatientRequired: false,
    });
    this.handleStates();
    this.gettingUserLists(selectedObject.userName);
    this.handleCloseContextMenuClick(event);
  };

  handleOpenDeleteDialog = () => {
    if (this.state["selectedRowID"]) {
      let selectedRow = this.state.data.filter(
        ({ id }) => id === this.state["selectedRowID"]
      );

      this.setState({
        openDeleteDialog: true,
        confirmedDeleteList: selectedRow,
      });
    } else {
      let selectedRows = this.state.data.filter(
        ({ id }) => this.state["selectedData"].indexOf(id) > -1
      );
      this.setState({
        openDeleteDialog: true,
        confirmedDeleteList: selectedRows,
      });
    }
  };

  handleCloseDeleteDialog = (event) => {
    if (this.state["selectedRowID"]) {
      this.setState({
        openDeleteDialog: false,
        selectedRowID: null,
        confirmedDeleteList: null,
        selectedData: [],
      });
      this.handleCloseContextMenuClick(event);
    } else
      this.setState({
        openDeleteDialog: false,
        selectedRowID: null,
        confirmedDeleteList: null,
        selectedData: [],
      });
  };

  handleConfirmDelete = (event) => {
    if (this.state["selectedRowID"]) {
      this.handleConfirmDeleteTask(event, "Single");
    } else this.handleConfirmDeleteTask(event, "Multiple");
    this.setState({ openDeleteDialog: false });
  };

  handleConfirmDeleteTask = (event, ope) => {
    this.setState({ loadingSpinner: true });
    let URL =
      ope === "Single"
        ? `taskmanager/${this.state["selectedRowID"]}`
        : "taskmanager/" + this.state["selectedData"].join(",");
    fetch(process.env.REACT_APP_BASEURL + URL, {
      method: "DELETE",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then(async (result) => {
        if (result) {
          this.setState({
            selectedData: [],
            selectedRowID: null,
            loadingSpinner: false,
          });
          this.handleCloseContextMenuClick(event);
          await this.gettingTaskManagerDetailsFromDB();
          this.emitNotificationEvent(this.state.selectedUserID);
        }
      })
      .catch((error) => {
        this.setState({
          selectedData: [],
          selectedRowID: null,
          loadingSpinner: false,
        });
        log(
          "Error Ocurred while deleting the user automation details",
          JSON.stringify(error["message"])
        );
      });
  };

  prepareTaskConfig = () => {
    let config = {
      taskTitle: String,
      action: String,
      reminderDate: Date,
      dueDate: Date,
      taskTypeID: String,
      userID: String,
      parentAccountID: String,
      status: String,
      priority: String,
      taskDetails: String,
      patientID: String,
      orderCode: String,
    };
    config["taskTitle"] = this.state.taskTitle;
    config["action"] = this.state.action;
    config["reminderDate"] = this.state.reminderDate;
    config["dueDate"] = this.state.dueDate;
    config["taskTypeID"] = this.state.selectedTaskTypeID;
    config["userID"] = this.state.selectedUserID;
    config["parentAccountID"] = sessionStorage.getItem("parentAccountId");
    config["status"] = this.state.status;
    config["priority"] = this.state.priority;
    config["taskDetails"] = this.state.taskDetails;
    config["patientID"] = this.state.selectedPatientID;
    config["orderCode"] = this.state.orderCode;
    return config;
  };

  handleSubmit = (event) => {
    try {
      event && event.preventDefault();
      let validate = {
        isTaskTitleRequired: this.prepareTaskConfig().taskTitle,
        isTaskDetailsRequired: this.prepareTaskConfig().taskDetails,
        isUserRequired: this.prepareTaskConfig().userID,
        isPatientRequired: this.prepareTaskConfig().patientID,
      };
      validate = Object.entries(validate)
        .filter(([key, value]) => ["", null, undefined].includes(value))
        .reduce((other, [key, node]) => ({ ...other, [key]: node }), {});
      if (Object.keys(validate).length) {
        if (validate.isTaskTitleRequired === "")
          this.setState({ isTaskTitleRequired: true });
        else this.setState({ isTaskTitleRequired: false });
        if (validate.isTaskDetailsRequired === "")
          this.setState({ isTaskDetailsRequired: true });
        else this.setState({ isTaskDetailsRequired: false });
        if (validate.isUserRequired === "")
          this.setState({ isUserRequired: true });
        else this.setState({ isUserRequired: false });
        if (validate.isPatientRequired === "")
          this.setState({ isPatientRequired: true });
        else this.setState({ isPatientRequired: false });
        return true;
      }

      this.setState({ loadingSpinner: true });
      fetch(process.env.REACT_APP_BASEURL + "taskmanager", {
        method: "POST",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(this.prepareTaskConfig()),
      })
        .then((response) => response.json())
        .then((response) => {
          this.setState({
            loadingSpinner: false,
            openTaskManagerDialog: false,
          });
        });
      toast.success(this.props.t('Toast.Success.TaskCreated'));
      let prepareUpdatedStates = {
        task_name: this.state.taskTitle,
        taskType: this.state.selectedTaskName,
        action: this.state.action,
        status: this.state.status,
        priority: this.state.priority,
        reminder_date: this.state.reminderDate,
        due_date: this.state.dueDate,
        patientName: this.state.selectedPatientName,
        userName: this.state.selectedUserName,
      };
      if (this.state.data.length === 0) {
        this.state.data.push(prepareUpdatedStates);
      } else this.state.data.unshift(prepareUpdatedStates);
      this.setState((state) => ({ data: state["data"] }));
      this.emitNotificationEvent(this.state.selectedUserID);
    } catch (SubmitException) {
      this.setState({
        loadingSpinner: false,
        openTaskManagerDialog: false,
      });
      log(
        "(TaskManager): Error ocurred while Submitting the task details!",
        SubmitException
      );
    }
  };

  handleUpdate = (event) => {
    try {
      event && event.preventDefault();
      let validate = {
        isTaskTitleRequired: this.prepareTaskConfig().taskTitle,
        isTaskDetailsRequired: this.prepareTaskConfig().taskDetails,
        isUserRequired: this.prepareTaskConfig().userID,
        isPatientRequired: this.prepareTaskConfig().patientID,
      };
      validate = Object.entries(validate)
        .filter(([key, value]) => ["", null, undefined].includes(value))
        .reduce((other, [key, node]) => ({ ...other, [key]: node }), {});
      if (Object.keys(validate).length) {
        if (validate.isTaskTitleRequired === "")
          this.setState({ isTaskTitleRequired: true });
        else this.setState({ isTaskTitleRequired: false });
        if (validate.isTaskDetailsRequired === "")
          this.setState({ isTaskDetailsRequired: true });
        else this.setState({ isTaskDetailsRequired: false });
        if (validate.isUserRequired === "")
          this.setState({ isUserRequired: true });
        else this.setState({ isUserRequired: false });
        if (validate.isPatientRequired === "")
          this.setState({ isPatientRequired: true });
        else this.setState({ isPatientRequired: false });
        return true;
      }

      this.setState({ loadingSpinner: true });
      let config = this.prepareTaskConfig();
      config["id"] = this.state["selectedRow"]["id"];
      fetch(process.env.REACT_APP_BASEURL + "taskmanager", {
        method: "PUT",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(config),
      })
        .then((response) => response.json())
        .then((response) => {
          this.setState({
            loadingSpinner: false,
            openTaskManagerDialog: false,
          });
          toast.success(this.props.t('Toast.Success.TaskUpdated'));
          this.gettingTaskManagerDetailsFromDB();
          this.setState({ selectedRow: {} });
          this.emitNotificationEvent(this.state.selectedUserID);
        });
    } catch (SubmitException) {
      this.setState({
        loadingSpinner: false,
        openTaskManagerDialog: false,
      });
      log(
        "(TaskManager): Error ocurred while Updating the task details!",
        SubmitException
      );
    }
  };

  renderStatusColor = (value) => {
    if (value === "Open") {
      return "#6554C1";
    }
    if (value === "InProgress") {
      return "#FFAB00";
    }
    if (value === "Complete") {
      return "#36B37E";
    }
  };

  renderPriorityColor = (value) => {
    if (value === "Low") {
      return "#0065FF";
    }
    if (value === "Medium") {
      return "#FFAB00";
    }
    if (["High", "Critical"].includes(value)) {
      return "#FF5630";
    }
  };

  renderActionColor = (value) => {
    if (value === "Open") {
      return "#6554C1";
    }
    if (value === "Complete") {
      return "#36B37E";
    }
    if (value === "Delete") {
      return "#FF5959";
    }
    if (value === "Close") {
      return "#FF5630";
    }
  };

  handleValidateFields = (value) => {
    if (!["", null, "null", undefined, "undefined"].includes(value)) {
      return value;
    }
    return null;
  };

  convertToTimezone = (date) => {
    return moment(date)
      .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
      .format("MM/DD/YYYY HH:mm");
  };

  handleChangeStatusFilterList = (event) => {
    const {
      target: { value },
    } = event;
    this.setState({ filterStatusList: value });
  };

  handleStatusListChange = (event) => {
    this.setState({
      filterStatusList: event.target.value,
    });
    setTimeout(async () => {
      filterObj["statusList"] = this.state.filterStatusList;
      await this.gettingTaskManagerDetailsFromDB();
    }, 200);
  };

  handlePriorityListChange = (event) => {
    this.setState({
      filterPriorityList: event.target.value,
    });
    setTimeout(async () => {
      filterObj["priorityList"] = this.state.filterPriorityList;
      await this.gettingTaskManagerDetailsFromDB();
    }, 200);
  };

  handleActionListChange = (event) => {
    this.setState({
      filterActionList: event.target.value,
    });
    setTimeout(async () => {
      filterObj["actionList"] = this.state.filterActionList;
      await this.gettingTaskManagerDetailsFromDB();
    }, 200);
  };

  setUserAutoCompleteAction = (value) => {
    this.setState({ openUserAutoComplete: value });
  };

  setPatientAutoCompleteAction = (value) => {
    this.setState({ openPatientAutoComplete: value });
  };

  onUserChange = (queryParam) => {
    if (queryParam.length > 3) {
      this.gettingUserLists(queryParam);
    }
  };

  onPatientChange = (queryParam) => {
    if (queryParam.length > 3) {
      this.gettingPatientList(queryParam);
    }
  };

  render() {
    const {
      openTaskManagerDialog,
      taskTitle,
      reminderDate,
      dueDate,
      userDataList,
      taskTypeList,
      selectedTaskTypeID,
      status,
      priority,
      patientDataList,
      operation,
      orderCode,
      taskDetails,
      totalRecords,
      data,
      isDataEmpty,
      selectedData,
      sortID,
      anchorEl,
      openDeleteDialog,
      confirmedDeleteList,
      filterStatusList,
      filterPriorityList,
      isTaskTitleRequired,
      isTaskDetailsRequired,
      isUserRequired,
      isPatientRequired,
      openUserAutoComplete,
      openPatientAutoComplete,
      selectedUser,
      selectedUserInputValue,
      selectedPatient,
      selectedPatientInputValue,
      locale
    } = this.state;
    const { classes, t } = this.props;
    const contextOpen = Boolean(anchorEl);
    const loading = openUserAutoComplete && userDataList.length === 0;
    const loadingPatient =
      openPatientAutoComplete && patientDataList.length === 0;
    const readOnly = operation === "View";
    const ITEM_HEIGHT = 50;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
      PaperProps: {
        style: {
          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          width: 250,
        },
      },
    };
    let ToolBar = (
      <Box sx={{ m: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <FormControl sx={{ width: "100%" }}>
              <InputLabel htmlFor="select-multiple-chip-store">
                {t("Task.Status")}
              </InputLabel>
              <Select
                multiple
                value={filterStatusList}
                onChange={this.handleStatusListChange}
                input={<Input id="select-multiple-chip-store" />}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip key={value} label={value} />
                    ))}
                  </Box>
                )}
                MenuProps={MenuProps}
              >
                {STATUS.map((items, index) => (
                  <MenuItem key={index} value={items}>
                    <Checkbox checked={filterStatusList.indexOf(items) > -1} />
                    <ListItemText primary={items} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl sx={{ width: "100%" }}>
              <InputLabel htmlFor="select-multiple-chip-store">
                {t("Task.Priority")}
              </InputLabel>
              <Select
                multiple
                value={filterPriorityList}
                onChange={this.handlePriorityListChange}
                input={<Input id="select-multiple-chip-store" />}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip key={value} label={value} />
                    ))}
                  </Box>
                )}
                MenuProps={MenuProps}
              >
                {PRIORITY.map((items, index) => (
                  <MenuItem key={index} value={items}>
                    <Checkbox
                      checked={filterPriorityList.indexOf(items) > -1}
                    />
                    <ListItemText primary={items} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          {/* <Grid item xs={4}>
            <FormControl sx={{ width: "100%" }}>
              <InputLabel htmlFor="select-multiple-chip-store">
                Action
              </InputLabel>
              <Select
                multiple
                value={filterActionList}
                onChange={this.handleActionListChange}
                input={<Input id="select-multiple-chip-store" />}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip key={value} label={value} />
                    ))}
                  </Box>
                )}
                MenuProps={MenuProps}
              >
                {ACTION.map((items, index) => (
                  <MenuItem key={index} value={items}>
                    <Checkbox checked={filterActionList.indexOf(items) > -1} />
                    <ListItemText primary={items} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid> */}
        </Grid>
      </Box>
    );

    return (
      <Box component="div">
        {this.renderLoaderIndicator()}
        <Box component="div" sx={{ width: "100%" }}>
          <Dialog
            maxWidth={"md"}
            fullWidth={true}
            open={openTaskManagerDialog || false}
            onClose={this.handleCloseTaskManagerDialog}
            aria-labelledby="form-dialog-title"
            PaperProps={{
              sx: { minWidth: "500px" },
            }}
          >
            {this.renderLoaderIndicator()}
            <BootstrapDialogTitle
              id="customized-dialog-title"
              onDialogClose={this.handleCloseTaskManagerDialog}
            >
              {operation} {t("Task.Task")}
            </BootstrapDialogTitle>
            <DialogContent dividers>
              <Grid container>
                <Grid item xs={12}>
                  <FormControl variant="standard" fullWidth>
                    <TextField
                      id="standard-basic"
                      label={t("Task.EnterYourTask")}
                      variant="standard"
                      value={taskTitle}
                      onChange={(event) =>
                        this.setState({
                          taskTitle: event.target.value,
                          isTaskTitleRequired: false,
                        })
                      }
                      disabled={Boolean(readOnly)}
                      error={isTaskTitleRequired}
                      helperText={
                        isTaskTitleRequired && t("Task.Validate.EnterTaskTitle")
                      }
                    />
                  </FormControl>
                </Grid>
                {/* <Grid item xs={2}>
                  <FormControl variant="standard" fullWidth>
                    <InputLabel id="demo-simple-select-standard-label">
                      Action
                    </InputLabel>
                    <Select
                      labelId="action-simple-select-standard-label"
                      id="action-simple-select-standard"
                      value={action}
                      onChange={(event) =>
                        this.setState({ action: event.target.value })
                      }
                      label="Action"
                      sx={{
                        ".MuiInput-input": {
                          color: "#1197B2",
                          fontWeight: "500",
                        },
                      }}
                      disabled={Boolean(readOnly)}
                    >
                      {ACTION.map((items, index) => (
                        <MenuItem
                          key={index}
                          selected
                          value={items}
                          sx={{
                            color: "#1197B2 !important",
                            fontWeight: "400",
                          }}
                        >
                          {items}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid> */}
              </Grid>
              <Grid container sx={{ mt: "10px" }}>
                <Grid item xs={6} sx={{ p: "0 10px 0 0" }}>
                  <FormControl fullWidth>
                    <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
                      <DesktopDatePicker
                        label={t("Task.ReminderDateLabel")}
                        value={reminderDate}
                        onChange={(date) =>
                          this.setState({ reminderDate: date })
                        }
                        disabled={Boolean(readOnly)}
                        // minDate={new Date()}
                        renderInput={(params) => (
                          <TextField
                            label={t("Task.ReminderDateLabel")}
                            variant="standard"
                            fullWidth
                            {...params}
                            sx={{
                              ".MuiInput-input": {
                                color: "#1197B2",
                                fontWeight: "500",
                              },
                            }}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Grid>
                <Grid item xs={6} sx={{ p: "0 0 0 10px" }}>
                  <FormControl fullWidth>
                    <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
                      <DesktopDatePicker
                        label={t("Task.DueDateLabel")}
                        value={dueDate}
                        onChange={(date) => this.setState({ dueDate: date })}
                        disabled={Boolean(readOnly)}
                        // minDate={new Date()}
                        renderInput={(params) => (
                          <TextField
                            label={t("Task.DueDateLabel")}
                            variant="standard"
                            fullWidth
                            {...params}
                            sx={{
                              ".MuiInput-input": {
                                color: "#1197B2",
                                fontWeight: "500",
                              },
                            }}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ mt: "0px" }}>
                <Grid item xs={6}>
                  <FormControl variant="standard" fullWidth>
                    <InputLabel id="demo-simple-select-standard-label">
                      {t("Task.TypeLabel")}
                    </InputLabel>
                    <Select
                      labelId="action-simple-select-standard-label"
                      id="action-simple-select-standard"
                      value={selectedTaskTypeID}
                      onChange={(event) => this.handleChangeTaskType(event)}
                      label="Type"
                      sx={{
                        ".MuiInput-input": {
                          color: "#1197B2",
                          fontWeight: "500",
                        },
                      }}
                      disabled={Boolean(readOnly)}
                    >
                      {taskTypeList &&
                        taskTypeList["length"] > 0 &&
                        taskTypeList.map((ele, index) => (
                          <MenuItem
                            key={index}
                            value={ele["id"]}
                            selected
                            sx={{
                              color: "#1197B2 !important",
                              fontWeight: "400",
                            }}
                          >
                            {ele["name"]}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl variant="standard" fullWidth>
                    <Autocomplete
                      id="search-unplugged-patient"
                      open={openUserAutoComplete}
                      onOpen={() => {
                        this.setUserAutoCompleteAction(true);
                      }}
                      onClose={() => {
                        this.setUserAutoCompleteAction(false);
                        this.handleChangeUsers(null, null, "clear");
                      }}
                      getOptionLabel={(option) => option.name}
                      options={userDataList}
                      loading={loading}
                      value={selectedUser}
                      inputValue={selectedUserInputValue}
                      onChange={this.handleChangeUsers}
                      onInputChange={(event, newInputValue) => {
                        this.setState({
                          selectedUserInputValue: newInputValue,
                        });
                      }}
                      disabled={Boolean(readOnly)}
                      sx={{
                        ".MuiAutocomplete-listbox": {
                          color: "#1197B2 !important",
                          fontWeight: "400",
                        },
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={t("Task.AssignedToLabel")}
                          variant="standard"
                          onChange={(ev) => {
                            if (
                              ev.target.value !== "" ||
                              ev.target.value !== null
                            ) {
                              this.onUserChange(ev.target.value);
                              this.setState({ isUserRequired: false });
                            }
                          }}
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <React.Fragment>
                                {loading && (
                                  <CircularProgress color="inherit" size={20} />
                                )}
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            ),
                          }}
                          error={isUserRequired}
                          helperText={
                            isUserRequired &&
                            t("Task.Validate.EnterAssignedTitle")
                          }
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ mt: "0px" }}>
                <Grid item xs={6}>
                  <FormControl variant="standard" fullWidth>
                    <InputLabel id="demo-simple-select-standard-label">
                      {t("Task.StatusLabel")}
                    </InputLabel>
                    <Select
                      labelId="action-simple-select-standard-label"
                      id="action-simple-select-standard"
                      value={status}
                      onChange={(event) =>
                        this.setState({ status: event.target.value })
                      }
                      label={t("Task.StatusLabel")}
                      sx={{
                        ".MuiInput-input": {
                          color: "#1197B2",
                          fontWeight: "500",
                        },
                      }}
                      disabled={Boolean(readOnly)}
                    >
                      {STATUS.map((items, index) => (
                        <MenuItem
                          key={index}
                          value={items}
                          selected
                          sx={{
                            color: "#1197B2 !important",
                            fontWeight: "400",
                          }}
                        >
                          {items}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl variant="standard" fullWidth>
                    <InputLabel id="demo-simple-select-standard-label">
                      {t("Task.PriorityLabel")}
                    </InputLabel>
                    <Select
                      labelId="action-simple-select-standard-label"
                      id="action-simple-select-standard"
                      value={priority}
                      onChange={(event) =>
                        this.setState({ priority: event.target.value })
                      }
                      label={t("Task.PriorityLabel")}
                      sx={{
                        ".MuiInput-input": {
                          color: "#1197B2",
                          fontWeight: "500",
                          ".Mui-disabled": {
                            color: "#1197B2",
                            fontWeight: "500",
                          },
                        },
                      }}
                      disabled={Boolean(readOnly)}
                    >
                      {PRIORITY.map((items, index) => (
                        <MenuItem
                          key={index}
                          value={items}
                          sx={{
                            color: "#1197B2 !important",
                            fontWeight: "400",
                          }}
                        >
                          {items}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container sx={{ mt: "15px" }}>
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <TextField
                      id="standard-basic"
                      label={t("Task.TaskDetailsLabel")}
                      variant="outlined"
                      multiline
                      rows={7}
                      onChange={(event) => {
                        this.setState({
                          taskDetails: event.target.value,
                          isTaskDetailsRequired: false,
                        });
                      }}
                      value={taskDetails}
                      disabled={Boolean(readOnly)}
                      error={isTaskDetailsRequired}
                      helperText={
                        isTaskDetailsRequired &&
                        t("Task.Validate.EnterTaskDetails")
                      }
                    />
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ mt: "0px" }}>
                <Grid item xs={6}>
                  <FormControl variant="standard" fullWidth>
                    <Autocomplete
                      id="search-unplugged-patient"
                      open={openPatientAutoComplete}
                      onOpen={() => {
                        this.setPatientAutoCompleteAction(true);
                      }}
                      onClose={() => {
                        this.setPatientAutoCompleteAction(false);
                        this.handleChangePatients(null, null, "clear");
                      }}
                      getOptionLabel={(option) => option.name}
                      options={patientDataList}
                      loading={loadingPatient}
                      value={selectedPatient}
                      inputValue={selectedPatientInputValue}
                      onChange={this.handleChangePatients}
                      onInputChange={(event, newInputValue) => {
                        this.setState({
                          selectedPatientInputValue: newInputValue,
                        });
                      }}
                      disabled={Boolean(readOnly)}
                      sx={{
                        ".MuiAutocomplete-listbox": {
                          color: "#1197B2 !important",
                          fontWeight: "400",
                        },
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={t("Task.PatientLabel")}
                          variant="standard"
                          onChange={(ev) => {
                            if (
                              ev.target.value !== "" ||
                              ev.target.value !== null
                            ) {
                              this.onPatientChange(ev.target.value);
                              this.setState({ isPatientRequired: false });
                            }
                          }}
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <React.Fragment>
                                {loadingPatient && (
                                  <CircularProgress color="inherit" size={20} />
                                )}
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            ),
                          }}
                          error={isPatientRequired}
                          helperText={
                            isPatientRequired && t("Task.Validate.EnterPatient")
                          }
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl variant="standard" fullWidth>
                    <TextField
                      id="standard-basic"
                      label={t("Task.OrderCode")}
                      variant="standard"
                      onChange={(event) => {
                        this.setState({ orderCode: event.target.value });
                      }}
                      value={orderCode}
                      disabled={Boolean(readOnly)}
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.handleCloseTaskManagerDialog}
                color="primary"
                className={classes["primaryButton"]}
              >
                {operation === "View" ? t("Task.Close") : t("Task.Cancel")}
              </Button>
              {operation !== "View" && (
                <Button
                  color="primary"
                  className={classes["primaryButton"]}
                  onClick={(event) => {
                    operation === "Add"
                      ? this.handleSubmit(event)
                      : this.handleUpdate(event);
                  }}
                >
                  {operation === "Add" ? t("Task.Save") : t("Task.Update")}
                </Button>
              )}
            </DialogActions>
          </Dialog>
          <Dialog
            maxWidth={"md"}
            fullWidth={true}
            open={openDeleteDialog || false}
            onClose={this.handleCloseDeleteDialog}
            aria-labelledby="form-dialog-title"
            PaperProps={{
              sx: { minWidth: "500px" },
            }}
          >
            {this.renderLoaderIndicator()}
            <BootstrapDialogTitle
              id="customized-dialog-title"
              onDialogClose={this.handleCloseDeleteDialog}
            >
              {t("Task.AreYouSureToDeleteText")}
            </BootstrapDialogTitle>
            <DialogContent dividers>
              <Box component="div">
                {confirmedDeleteList &&
                  confirmedDeleteList.map((ele, index) => (
                    <Box
                      component="div"
                      key={index}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        m: "0.5rem",
                      }}
                    >
                      {" • "} {ele["task_name"]}
                    </Box>
                  ))}
              </Box>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.handleCloseDeleteDialog}
                color="primary"
                className={classes["primaryButton"]}
              >
                {t("Task.Cancel")}
              </Button>
              <Button
                color="primary"
                className={classes["primaryButton"]}
                onClick={this.handleConfirmDelete}
              >
                {t("Task.Delete")}
              </Button>
            </DialogActions>
          </Dialog>
          <EnhancedTableToolbar
            TotalRowsSelected={selectedData.length || 0}
            openTaskManagerDialogClick={this.handleOpenTaskManagerDialog}
            DeleteTaskClick={this.handleOpenDeleteDialog}
          />
          {selectedData.length === 0 && ToolBar}
        </Box>
        <Divider />
        <Box component="div" sx={{ overflowX: "auto" }}>
          <Menu
            id="Automation-Menu"
            anchorEl={anchorEl}
            open={contextOpen}
            onClose={this.handleCloseContextMenuClick}
            PaperProps={{
              style: {
                maxHeight: 48 * 4.5,
                width: 200,
              },
            }}
          >
            <MenuItem
              key="view"
              onClick={this.handleOpenView}
              sx={{ height: "40px" }}
            >
              <ListItemText>{t("Task.ViewAction")}</ListItemText>
            </MenuItem>
            <MenuItem
              key="edit"
              onClick={this.handleOpenEdit}
              sx={{ height: "40px" }}
            >
              <ListItemText>{t("Task.EditAction")}</ListItemText>
            </MenuItem>
            <MenuItem
              key="delete"
              onClick={this.handleOpenDeleteDialog}
              sx={{ height: "40px" }}
            >
              <ListItemText>{t("Task.DeleteAction")}</ListItemText>
            </MenuItem>
          </Menu>
          <Table>
            <EnhancedTableHead
              totalRowsSelected={selectedData.length}
              order={filterObj["sortOrder"]}
              orderBy={filterObj["sortColumn"]}
              onSelectAllCheckBoxClick={this.handleSelectAllCheckBoxClick}
              onRequestSort={this.handleRequestSort}
              rowCount={data.length || 0}
              sortID={sortID}
            />
            <TableBody>
              {Array.isArray(data) && data.length === 0 ? (
                <TableRow>
                  <TableCell
                    colSpan={20}
                    style={{ textAlign: "center", padding: "10px 0px" }}
                  >
                    {isDataEmpty && t("Task.NoDataFound")}
                  </TableCell>
                </TableRow>
              ) : (
                data &&
                data.length > 0 &&
                stableSort(
                  data,
                  getSorting(filterObj["sortOrder"], filterObj["sortColumn"])
                ).map((items, index) => {
                  const isSelected = this.isSelected(items["id"]);

                  const sx = {
                    color: "rgba(0, 0, 0, 0.87)",
                    fontSize: "0.8125rem",
                    fontWeight: 400,
                  };
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isSelected}
                      tabIndex={-1}
                      key={index}
                      selected={isSelected}
                      sx={{ height: "50px" }}
                    >
                      <TableCell
                        padding="checkbox"
                        onClick={(event) =>
                          this.handleCheckBoxOrRowClick(event, items["id"])
                        }
                        sx={{ padding: "0 12px" }}
                      >
                        <Checkbox
                          checked={isSelected}
                          sx={{ "&.Mui-checked": { color: "#0ae" } }}
                          onClick={(event) =>
                            this.handleCheckBoxOrRowClick(event, items["id"])
                          }
                        />
                      </TableCell>
                      <TableCell padding={"none"} component="th" scope="row">
                        <Stack direction="row" spacing={1}>
                          {this.handleValidateFields(items["task_name"]) &&
                            (String(items["task_name"]).trim().length > 10 ? (
                              <HTMLTooltip
                                key="single-edit"
                                placement="right"
                                title={
                                  <React.Fragment>
                                    <Typography color="inherit">
                                      {items["task_name"]}
                                    </Typography>
                                  </React.Fragment>
                                }
                              >
                                <Typography
                                  color="inherit"
                                  sx={{
                                    fontSize: "0.8125rem",
                                  }}
                                >
                                  {items["task_name"].slice(0, 3) + "..."}
                                </Typography>
                              </HTMLTooltip>
                            ) : (
                              items["task_name"]
                            ))}
                        </Stack>
                      </TableCell>
                      <TableCell
                        padding={"none"}
                        sx={{ ...sx }}
                        onClick={(event) =>
                          this.handleCheckBoxOrRowClick(event, items["id"])
                        }
                      >
                        {this.handleValidateFields(items["taskType"])}
                      </TableCell>

                      <TableCell
                        padding={"none"}
                        sx={{ ...sx }}
                        onClick={(event) =>
                          this.handleCheckBoxOrRowClick(event, items["id"])
                        }
                      >
                        {this.handleValidateFields(items["status"]) && (
                          <Chip
                            label={items["status"]}
                            variant="outlined"
                            size="medium"
                            sx={{
                              "&.MuiChip-root": {
                                color: this.renderStatusColor(items["status"]),
                                border: `2px solid ${this.renderStatusColor(
                                  items["status"]
                                )}`,
                              },
                            }}
                          ></Chip>
                        )}
                      </TableCell>
                      <TableCell
                        padding={"none"}
                        sx={{ ...sx }}
                        onClick={(event) =>
                          this.handleCheckBoxOrRowClick(event, items["id"])
                        }
                      >
                        {this.handleValidateFields(items["priority"]) && (
                          <Chip
                            label={items["priority"]}
                            variant="outlined"
                            size="medium"
                            sx={{
                              "&.MuiChip-root": {
                                color: this.renderPriorityColor(
                                  items["priority"]
                                ),
                                border: `2px solid ${this.renderPriorityColor(
                                  items["priority"]
                                )}`,
                              },
                            }}
                          ></Chip>
                        )}
                      </TableCell>
                      <TableCell
                        padding={"none"}
                        sx={{ ...sx }}
                        onClick={(event) =>
                          this.handleCheckBoxOrRowClick(event, items["id"])
                        }
                      >
                        {this.handleValidateFields(items["reminder_date"]) &&
                          this.convertToTimezone(items["reminder_date"])}
                      </TableCell>
                      <TableCell
                        padding={"none"}
                        sx={{ ...sx }}
                        onClick={(event) =>
                          this.handleCheckBoxOrRowClick(event, items["id"])
                        }
                      >
                        {this.handleValidateFields(items["due_date"]) &&
                          this.convertToTimezone(items["due_date"])}
                      </TableCell>
                      {/* <TableCell
                        padding={"none"}
                        sx={{ ...sx }}
                        onClick={(event) =>
                          this.handleCheckBoxOrRowClick(event, items["id"])
                        }
                      >
                        {this.handleValidateFields(items["action"]) && (
                          <Chip
                            label={items["action"]}
                            variant="outlined"
                            size="medium"
                            sx={{
                              "&.MuiChip-root": {
                                color: this.renderActionColor(items["action"]),
                                border: `2px solid ${this.renderActionColor(
                                  items["action"]
                                )}`,
                              },
                            }}
                          ></Chip>
                        )}
                      </TableCell> */}
                      <TableCell
                        padding={"none"}
                        sx={{ ...sx }}
                        onClick={(event) =>
                          this.handleCheckBoxOrRowClick(event, items["id"])
                        }
                      >
                        {this.handleValidateFields(items["patientName"]) &&
                          items["patientName"]}
                      </TableCell>
                      <TableCell
                        padding={"none"}
                        sx={{ ...sx }}
                        onClick={(event) =>
                          this.handleCheckBoxOrRowClick(event, items["id"])
                        }
                      >
                        {this.handleValidateFields(items["userName"]) &&
                          items["userName"]}
                      </TableCell>
                      <TableCell padding={"none"} sx={{ ...sx }}>
                        <IconButton
                          aria-label="More"
                          aria-owns={contextOpen ? "long-menu" : null}
                          aria-haspopup="true"
                          onClick={(event) =>
                            this.handleOpenContextMenuClick(event, items)
                          }
                        >
                          <MoreVertIcon style={{ fontSize: 20 }} />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </Box>
        <ThemeProvider theme={localeTheme}>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={totalRecords || 0}
            rowsPerPage={filterObj["pageSize"]}
            page={filterObj["pageNo"]}
            backIconButtonProps={{
              "aria-label": "Previous Page",
            }}
            nextIconButtonProps={{
              "aria-label": "Next Page",
            }}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
          />
        </ThemeProvider>
      </Box>
    );
  }
}

export default withStyles(useStyles, { withTheme: true })(
  withTranslation()(TaskManager)
);



// WEBPACK FOOTER //
// ./src/components/taskmanager/index.js